import { useCallback, useEffect, useMemo, useState } from "react";
import axios from "axios";
import Modal from "../NCadetes/Modal";
import AusenciasYSanciones from "./AusenciasYSanciones";
import AvisoInasistenciaDocente from "../Docentes/ModuloAvisosAusenciasDocentes";
import ModuloSanidadAusenciasDocentes from "../Sanidad/ModuloSanidadAusenciasDocentes"; 
import "./notificaciones.css";
import comprueboPermisos from '../tools/comprueboPermisos.js';
import ObtieneDatosCookies from "../obtieneDatosCookiesUsuario";
/*
|--------------------------------------------------------------------------
| Endpoints
|--------------------------------------------------------------------------
*/

const ENDPOINTS = {
  cadetes:
    "https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/obtenerAusenciasMayores",
};

/*
|--------------------------------------------------------------------------
| Permisos
|--------------------------------------------------------------------------
*/



const Notificaciones = ({

  mostrame = false,
  cierro,
}) => {
  const [mostrarNotificaciones, setMostrarNotificaciones] =
    useState(false);

  const [seccionActiva, setSeccionActiva] = useState("");

  const [datosCadetes, setDatosCadetes] = useState(null);
  const [cargando, setCargando] = useState({
    cadetes: false,
  });

  const [errores, setErrores] = useState({
    cadetes: "",
  });

  const [seccionesCargadas, setSeccionesCargadas] = useState({
    cadetes: false,
  });

  const [isMobile, setIsMobile] = useState(false);
const Usuario=ObtieneDatosCookies()
  /*
  |--------------------------------------------------------------------------
  | Comprobación de permisos
  |--------------------------------------------------------------------------
  */

  const permisosUsuario = useMemo(() => {
    const funcion = Usuario?.funcion;

    if (Array.isArray(funcion)) {
      return funcion
        .map((permiso) => String(permiso).trim())
        .filter(Boolean);
    }

    if (typeof funcion === "string") {
      return funcion
        .split(",")
        .map((permiso) => permiso.trim())
        .filter(Boolean);
    }

    return [];
  }, [Usuario?.funcion]);

  const tienePermiso = useCallback(
    (permisoBuscado) => {
      const permisoNormalizado = String(
        permisoBuscado || ""
      )
        .trim()
        .toLowerCase();

      return permisosUsuario.some(
        (permiso) =>
          String(permiso)
            .trim()
            .toLowerCase() === permisoNormalizado
      );
    },
    [permisosUsuario]
  );

  /*
  |--------------------------------------------------------------------------
  | Permisos individuales
  |--------------------------------------------------------------------------
  |
  | Si querés que Cadetes aparezca SIEMPRE, dejá:
  |
  | const tienePermisoCadetes = true;
  |
  | Si querés respetar el permiso "Cadetes", usamos tienePermiso.
  |
  */

  const tienePermisoCadetes =
   comprueboPermisos(Usuario.funcion,"Novedades Cadetes") || false;
  const tienePermisoSanidad =
   tienePermiso("Novedades Sanidad") || false;

  const tienePermisoEstudio = false;

  const tienePermisoDocentes =
   tienePermiso("Novedades Docentes") || false;

  /*
  |--------------------------------------------------------------------------
  | Secciones disponibles
  |--------------------------------------------------------------------------
  */

  const seccionesDisponibles = useMemo(() => {
    const secciones = [];

    if (tienePermisoCadetes) {
      secciones.push({
        id: "cadetes",
        titulo: "Cadetes",
        descripcion: "Inasistencias y sanciones",
        icono: "C",
      });
    }

    if (tienePermisoSanidad) {
      secciones.push({
        id: "sanidad",
        titulo: "Sanidad",
        descripcion: "Novedades y controles sanitarios",
        icono: "🩺",
      });
    }

    if (tienePermisoEstudio) {
      secciones.push({
        id: "estudio",
        titulo: "Estudio",
        descripcion: "Novedades académicas",
        icono: "📚",
      });
    }

    if (tienePermisoDocentes) {
      secciones.push({
        id: "docentes",
        titulo: "Docentes",
        descripcion: "Avisos de inasistencia docente",
        icono: "👨‍🏫",
      });
    }

    return secciones;
  }, [
    tienePermisoCadetes,
    tienePermisoSanidad,
    tienePermisoEstudio,
    tienePermisoDocentes,
  ]);

  /*
  |--------------------------------------------------------------------------
  | Carga genérica de información
  |--------------------------------------------------------------------------
  */

  const cargarSeccion = useCallback(
    async (seccion, forzar = false) => {
      if (!seccion) return;

      /*
      |--------------------------------------------------------------------------
      | SOLO CADETES SE CARGA DESDE NOTIFICACIONES
      |--------------------------------------------------------------------------
      |
      | Docentes y Sanidad cargan su propia información dentro de sus
      | respectivos componentes.
      |
      */

      if (seccion !== "cadetes") {
        return;
      }

      if (
        seccionesCargadas.cadetes &&
        !forzar
      ) {
        return;
      }

      try {
        setCargando((estadoAnterior) => ({
          ...estadoAnterior,
          cadetes: true,
        }));

        setErrores((estadoAnterior) => ({
          ...estadoAnterior,
          cadetes: "",
        }));

        const response = await axios.post(
          ENDPOINTS.cadetes
        );

        setDatosCadetes(
          response.data || null
        );

        setSeccionesCargadas(
          (estadoAnterior) => ({
            ...estadoAnterior,
            cadetes: true,
          })
        );
      } catch (error) {
        console.error(
          "Error cargando notificaciones de cadetes:",
          error
        );

        let mensaje =
          "No fue posible cargar la información.";

        if (error.response?.status === 401) {
          mensaje =
            "La sesión venció o no está autorizada.";
        }

        if (error.response?.status === 403) {
          mensaje =
            "No posee permiso para consultar esta sección.";
        }

        if (error.response?.status === 404) {
          mensaje =
            "El servicio de esta sección todavía no está disponible.";
        }

        setErrores((estadoAnterior) => ({
          ...estadoAnterior,
          cadetes: mensaje,
        }));
      } finally {
        setCargando((estadoAnterior) => ({
          ...estadoAnterior,
          cadetes: false,
        }));
      }
    },
    [seccionesCargadas.cadetes]
  );

  /*
  |--------------------------------------------------------------------------
  | Seleccionar primera sección permitida
  |--------------------------------------------------------------------------
  */

  useEffect(() => {
    if (!seccionesDisponibles.length) {
      setSeccionActiva("");
      return;
    }

    const seccionActualPermitida =
      seccionesDisponibles.some(
        (seccion) =>
          seccion.id === seccionActiva
      );

    if (!seccionActualPermitida) {
      setSeccionActiva(
        seccionesDisponibles[0].id
      );
    }
  }, [
    seccionesDisponibles,
    seccionActiva,
  ]);

  /*
  |--------------------------------------------------------------------------
  | Cargar sección seleccionada
  |--------------------------------------------------------------------------
  */

  useEffect(() => {
    if (!seccionActiva) return;

    cargarSeccion(seccionActiva);
  }, [
    seccionActiva,
    cargarSeccion,
  ]);

  /*
  |--------------------------------------------------------------------------
  | Apertura automática del modal
  |--------------------------------------------------------------------------
  */

  useEffect(() => {
    if (mostrame) {
      setMostrarNotificaciones(true);
      return;
    }

    const ahora = new Date();

    const ultimaVista =
      localStorage.getItem(
        "ultimaVistaNotificaciones"
      );

    if (!ultimaVista) {
      setMostrarNotificaciones(true);

      localStorage.setItem(
        "ultimaVistaNotificaciones",
        ahora.toISOString()
      );

      return;
    }

    const fechaUltimaVista =
      new Date(ultimaVista);

    if (
      Number.isNaN(
        fechaUltimaVista.getTime()
      )
    ) {
      setMostrarNotificaciones(true);

      localStorage.setItem(
        "ultimaVistaNotificaciones",
        ahora.toISOString()
      );

      return;
    }

    const proximaHoraPermitida =
      new Date(fechaUltimaVista);

    proximaHoraPermitida.setDate(
      proximaHoraPermitida.getDate() + 1
    );

    proximaHoraPermitida.setHours(
      11,
      0,
      0,
      0
    );

    if (
      ahora >= proximaHoraPermitida
    ) {
      setMostrarNotificaciones(true);

      localStorage.setItem(
        "ultimaVistaNotificaciones",
        ahora.toISOString()
      );
    }
  }, [mostrame]);

  /*
  |--------------------------------------------------------------------------
  | Responsive
  |--------------------------------------------------------------------------
  */

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(
        window.innerWidth < 600
      );
    };

    handleResize();

    window.addEventListener(
      "resize",
      handleResize
    );

    return () => {
      window.removeEventListener(
        "resize",
        handleResize
      );
    };
  }, []);

  /*
  |--------------------------------------------------------------------------
  | Cerrar
  |--------------------------------------------------------------------------
  */

  const handleClose = () => {
    setMostrarNotificaciones(false);

    localStorage.setItem(
      "ultimaVistaNotificaciones",
      new Date().toISOString()
    );

    if (
      typeof cierro === "function"
    ) {
      cierro();
    }
  };

  const seleccionarSeccion = (
    seccion
  ) => {
    setSeccionActiva(seccion);
  };

  const reintentarSeccion = () => {
    if (!seccionActiva) return;

    cargarSeccion(
      seccionActiva,
      true
    );
  };

  /*
  |--------------------------------------------------------------------------
  | Verificar existencia de datos
  |--------------------------------------------------------------------------
  */

  const tieneDatos = (datos) => {
    if (
      datos === null ||
      datos === undefined
    ) {
      return false;
    }

    if (Array.isArray(datos)) {
      return datos.length > 0;
    }

    if (
      typeof datos === "object"
    ) {
      return (
        Object.keys(datos).length > 0
      );
    }

    return Boolean(datos);
  };

  /*
  |--------------------------------------------------------------------------
  | Contenido activo
  |--------------------------------------------------------------------------
  */

  const renderContenidoActivo = () => {
    if (!seccionActiva) {
      return (
        <EstadoSinPermisos />
      );
    }

    /*
    |--------------------------------------------------------------------------
    | DOCENTES
    |--------------------------------------------------------------------------
    |
    | Se controla antes del loading genérico porque este módulo
    | carga sus propios datos.
    |
    */

    if (
      seccionActiva === "docentes"
    ) {
      return (
        <div className="notifications-component-container notifications-docentes-container">
          <AvisoInasistenciaDocente
            Usuario={Usuario}
          />
        </div>
      );
    }
        if (
      seccionActiva === "sanidad"
    ) {
      return (
        <div className="notifications-component-container notifications-docentes-container">
          <ModuloSanidadAusenciasDocentes
            Usuario={Usuario}
          />
        </div>
      );
    }

    if (
      cargando[seccionActiva]
    ) {
      return (
        <EstadoCargando />
      );
    }

    if (
      errores[seccionActiva]
    ) {
      return (
        <EstadoError
          mensaje={
            errores[
              seccionActiva
            ]
          }
          onReintentar={
            reintentarSeccion
          }
        />
      );
    }

    /*
    |--------------------------------------------------------------------------
    | CADETES
    |--------------------------------------------------------------------------
    */

    if (
      seccionActiva === "cadetes"
    ) {
      if (
        !tieneDatos(
          datosCadetes
        )
      ) {
        return (
          <EstadoSinDatos
            titulo="No hay inasistencias o sanciones"
            descripcion="No existen novedades de cadetes para mostrar."
          />
        );
      }

      return (
        <div className="notifications-component-container">
          <AusenciasYSanciones
            data={datosCadetes}
          />
        </div>
      );
    }

    return null;
  };

  /*
  |--------------------------------------------------------------------------
  | Render principal
  |--------------------------------------------------------------------------
  */

  return (
    <>
      {mostrarNotificaciones && (
        <Modal
          isOpen={
            mostrarNotificaciones
          }
          onClose={
            handleClose
          }
        >
          <section className="notifications-modal">
            <header className="notifications-header">

              <div className="notifications-header-icon">
                <span aria-hidden="true">
                  🔔
                </span>
              </div>

              <div className="notifications-header-content">
                <span className="notifications-eyebrow">
                  Centro de novedades
                </span>

                <h2 className="notifications-title">
                  Información importante
                </h2>

                <p className="notifications-subtitle">
                  Consultá las novedades
                  disponibles según tus
                  permisos.
                </p>
              </div>

              <button
                type="button"
                className="notifications-header-close"
                onClick={
                  handleClose
                }
                aria-label="Cerrar notificaciones"
                title="Cerrar"
              >
                ×
              </button>
            </header>

            {seccionesDisponibles.length >
              0 && (
              <nav className="notifications-navigation">

                {seccionesDisponibles.map(
                  (seccion) => (
                    <button
                      key={
                        seccion.id
                      }
                      type="button"
                      className={
                        seccionActiva ===
                        seccion.id
                          ? "notifications-tab notifications-tab-active"
                          : "notifications-tab"
                      }
                      onClick={() =>
                        seleccionarSeccion(
                          seccion.id
                        )
                      }
                    >
                      <span className="notifications-tab-icon">
                        {
                          seccion.icono
                        }
                      </span>

                      <span className="notifications-tab-text">
                        <strong>
                          {
                            seccion.titulo
                          }
                        </strong>

                        {!isMobile && (
                          <small>
                            {
                              seccion.descripcion
                            }
                          </small>
                        )}
                      </span>

                      {errores[
                        seccion.id
                      ] && (
                        <span
                          className="notifications-tab-error"
                          title="Error al cargar"
                        >
                          !
                        </span>
                      )}
                    </button>
                  )
                )}
              </nav>
            )}

            <div className="notifications-body">
              {
                renderContenidoActivo()
              }
            </div>

            <footer className="notifications-footer">
              <span>
                Información actualizada
                desde el sistema ISeP
              </span>

              <div className="notifications-footer-actions">

                {seccionActiva ===
                  "cadetes" && (
                    <button
                      type="button"
                      className="notifications-refresh-button"
                      onClick={() =>
                        cargarSeccion(
                          seccionActiva,
                          true
                        )
                      }
                      disabled={
                        cargando[
                          seccionActiva
                        ]
                      }
                    >
                      ↻ Actualizar
                    </button>
                  )}

                <button
                  type="button"
                  className="notifications-close-button"
                  onClick={
                    handleClose
                  }
                >
                  Cerrar
                </button>
              </div>
            </footer>
          </section>
        </Modal>
      )}
    </>
  );
};

/*
|--------------------------------------------------------------------------
| Estado cargando
|--------------------------------------------------------------------------
*/

const EstadoCargando = () => {
  return (
    <div className="notifications-state">
      <div className="notifications-spinner" />

      <h3>
        Cargando información
      </h3>

      <p>
        Estamos consultando las
        novedades más recientes.
      </p>
    </div>
  );
};

/*
|--------------------------------------------------------------------------
| Estado error
|--------------------------------------------------------------------------
*/

const EstadoError = ({
  mensaje,
  onReintentar,
}) => {
  return (
    <div className="notifications-state notifications-error">

      <div className="notifications-state-icon notifications-state-icon-error">
        !
      </div>

      <h3>
        No pudimos cargar la
        información
      </h3>

      <p>
        {mensaje}
      </p>

      <button
        type="button"
        className="notifications-button"
        onClick={
          onReintentar
        }
      >
        Reintentar
      </button>
    </div>
  );
};

/*
|--------------------------------------------------------------------------
| Sin datos
|--------------------------------------------------------------------------
*/

const EstadoSinDatos = ({
  titulo,
  descripcion,
}) => {
  return (
    <div className="notifications-state">

      <div className="notifications-state-icon">
        ✓
      </div>

      <h3>
        {titulo}
      </h3>

      <p>
        {descripcion}
      </p>
    </div>
  );
};

/*
|--------------------------------------------------------------------------
| Sin permisos
|--------------------------------------------------------------------------
*/

const EstadoSinPermisos = () => {
  return (
    <div className="notifications-state notifications-no-permission">

      <div className="notifications-state-icon notifications-state-icon-lock">
        🔒
      </div>

      <h3>
        Sin secciones disponibles
      </h3>

      <p>
        El usuario no posee permisos
        para consultar las secciones
        disponibles.
      </p>
    </div>
  );
};

export default Notificaciones;